import { useEffect, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';

import LoadingIndicator from 'components/loading-indicator';
import { DrawerActions, DrawerContent, DrawerSection, RightDrawer, Spacer } from 'styled/components';
import { getInvoicingSystemServicesForImport } from 'api/service';

function ImportServices({ open, handleClose, handleConfirm }) {
  const [ready, setReady] = useState(false);
  const [invoicingSystemServices, setInvoicingSystemServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState({});

  useEffect(() => (open ? onOpen() : onClose()), [open]);

  const onOpen = () => {
    getInvoicingSystemServicesForImport()
      .then(services => {
        setInvoicingSystemServices(services);
        setReady(true);
      })
      .catch(err => {
        console.error(err);
        handleClose();
      });
  };

  const onClose = () => {
    setReady(false);
    setInvoicingSystemServices([]);
    setSelectedServices({});
  };

  const toggleService = (service) => {
    if (service.imported) {
      return;
    }
    const result = { ...selectedServices };
    if (result[service.id]) {
      delete result[service.id];
    } else {
      result[service.id] = true;
    }
    setSelectedServices(result);
  };

  const handleConfirmButtonClicked = () => {
    handleConfirm(invoicingSystemServices.filter(service => selectedServices[service.id]));
  };

  const selectedCount = Object.keys(selectedServices).length;

  return (
    <RightDrawer
      open={open}
      onOpen={() => {
      }}
      onClose={handleClose}
      aria-labelledby="Import services from Odoo"
      anchor="right"
      maxWidth="housekeepingDrawerWidth"
    >
      <AppBar position="relative">
        <Toolbar>
          <Typography fontWeight="bold">Import services from Odoo</Typography>
          <Spacer />
          <IconButton onClick={handleClose}>
            <CloseIcon sx={{ color: '#fff' }} />
          </IconButton>
        </Toolbar>
      </AppBar>
      <DrawerContent>
        <DrawerSection>
          {!ready && <LoadingIndicator />}
          {ready && invoicingSystemServices.length === 0 && (
            <Typography>There are no services in the configured Odoo instance.</Typography>
          )}
          {ready && invoicingSystemServices.map(service => (
            <div key={service.id}>
              <FormControlLabel
                label={service.imported ? `${service.name} (Already imported)` : service.name}
                control={(
                  <Checkbox
                    checked={Boolean(service.imported || selectedServices[service.id])}
                    disabled={service.imported}
                    inputProps={{ 'aria-label': service.name }}
                  />
                )}
                onChange={() => toggleService(service)}
              />
            </div>
          ))}
        </DrawerSection>
      </DrawerContent>
      <DrawerActions>
        <Button
          variant="contained"
          sx={{ width: '100%' }}
          onClick={handleConfirmButtonClicked}
          disabled={selectedCount === 0}
        >
          Import{selectedCount > 0 ? ` ${selectedCount} selected` : ''}
        </Button>
      </DrawerActions>
    </RightDrawer>
  );
}

export default ImportServices;
